import { Box, Typography } from "@mui/material";
import React from "react";

const JobLogs = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <Box
      sx={{
        borderLeft: "1px solid #B027CE",
        pl: 1,
        borderWidth: "2px",
      }}
    >
      <Typography color={"#470056"}>Logs</Typography>
      <Box
        sx={{
          bgcolor: "#FFFFFF",
          border: "1px solid #A3A3A3",
          p: 1,
          borderRadius: "8px",
          mt: 1,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 400 }} color={"#B00000"}>
          {errorMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default JobLogs;
